import React from 'react';
import NotificationTemplate from "./NotificationTemplate";
import Utils from "../../Utils";
import {UserRoles} from "../../Constants";
import history from '../../../history';

function UserRegistrationTemplate({ payload, onClick }) {

    return <NotificationTemplate title={"New User Registration"}
                                 onClick={() => {

                                     switch (payload.user_role) {
                                         case UserRoles.Farmer:
                                             history.push(`/farmers?filter_id=${payload.farmer_id}&q=${payload.name}`);
                                             break;
                                         case UserRoles.FBO:
                                             history.push(`/fbo?filter_id=${payload.fbo_id}&q=${payload.name}`);
                                             break;
                                         case UserRoles.Owner:
                                             history.push(`/tractor_owners?filter_id=${payload.owner_id}&q=${payload.name}`);
                                             break;
                                     }

                                     if(onClick){
                                         onClick();
                                     }

                                 }}
                                 properties={[
                                     {
                                         title: "Full Name",
                                         value: payload.name
                                     },
                                     {
                                         title: "Phone No.",
                                         value: payload.phone
                                     },
                                     {
                                         title: "Email",
                                         value: payload.email
                                     },
                                     {
                                         title: "Account Type",
                                         value: Utils.formatRole(payload.user_role)
                                     }
                                 ]}/>

}

export default UserRegistrationTemplate;


// WEBPACK FOOTER //
// ./src/common/UserNotifications/PopupTemplates/UserRegistration.js